import axios from 'axios';
import fileDownload from 'js-file-download';
import moment from 'moment';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import _ from 'underscore';
import { errorMsg, log } from 'utils';
import { url } from 'utils/url';

export const ANALYTICS_FETCH_DATA_INIT = createAction(
  'ANALYTICS_FETCH_DATA_INIT'
);
export const ANALYTICS_FETCH_DATA_SUCCESS = createAction(
  'ANALYTICS_FETCH_DATA_SUCCESS'
);
export const ANALYTICS_FETCH_PROFILE_SUCCESS = createAction(
  'ANALYTICS_FETCH_PROFILE_SUCCESS'
);
export const ANALYTICS_EXPORT_ANALYTIC_INIT = createAction(
  'ANALYTICS_EXPORT_ANALYTIC_INIT'
);
export const ANALYTICS_EXPORT_ANALYTIC_SUCCESS = createAction(
  'ANALYTICS_EXPORT_ANALYTIC_SUCCESS'
);
export const ANALYTICS_EXPORT_ANALYTIC_FAIL = createAction(
  'ANALYTICS_EXPORT_ANALYTIC_FAIL'
);
export const ANALYTICS_FETCH_DATA_FAIL = createAction(
  'ANALYTICS_FETCH_DATA_FAIL'
);
export const ANALYTICS_CALCULATE_DATA_INIT = createAction(
  'ANALYTICS_CALCULATE_DATA_INIT'
);
export const ANALYTICS_CALCULATE_DATA_SUCCESS = createAction(
  'ANALYTICS_CALCULATE_DATA_SUCCESS'
);
export const ANALYTICS_FETCH_LEADERBOARD_INIT = createAction(
  'ANALYTICS_FETCH_LEADERBOARD_INIT'
);
export const ANALYTICS_FETCH_LEADERBOARD_SUCCESS = createAction(
  'ANALYTICS_FETCH_LEADERBOARD_SUCCESS'
);
export const ANALYTICS_FETCH_LEADERBOARD_FAIL = createAction(
  'ANALYTICS_FETCH_LEADERBOARD_FAIL'
);
export const ANALYTICS_FETCH_GAZE_LOCATIONS_SUCCESS = createAction(
  'ANALYTICS_FETCH_GAZE_LOCATIONS_SUCCESS'
);
export const ANALYTICS_FETCH_PROGRAMMATIC_INIT = createAction(
  'ANALYTICS_FETCH_PROGRAMMATIC_INIT'
);
export const ANALYTICS_FETCH_PROGRAMMATIC_SUCCESS = createAction(
  'ANALYTICS_FETCH_PROGRAMMATIC_SUCCESS'
);
export const ANALYTICS_FETCH_PROGRAMMATIC_FAIL = createAction(
  'ANALYTICS_FETCH_PROGRAMMATIC_FAIL'
);

// The Analytics page holds dayjs objects; this page's other actions get moment.
// Both expose format(), so send a plain date string and let the API parse it.
const formatDay = (value) => {
  if (!value) return undefined;
  return value.format ? value.format('YYYY-MM-DD') : value;
};

// Hourly programmatic ad funnel. Only hours with activity come back; the table
// is sorted ascending by `hour` (YYYY-MM-DD-HH, already SGT — never re-offset).
export const fetchProgrammaticAnalytics = ({ siteId, start, end, screenId }) => {
  return async (dispatch) => {
    dispatch(ANALYTICS_FETCH_PROGRAMMATIC_INIT());
    let res;
    try {
      res = await axios.post(
        `${url}/analytic/getProgrammatic`,
        {
          siteId,
          start: formatDay(start),
          end: formatDay(end),
          screenId: screenId || undefined,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
    } catch (error) {
      toastr.error('', `${errorMsg(dispatch, error)}`);
      return dispatch(ANALYTICS_FETCH_PROGRAMMATIC_FAIL({ error }));
    }

    const data = res.data.data || {};
    return dispatch(
      ANALYTICS_FETCH_PROGRAMMATIC_SUCCESS({
        table: data.table || [],
        totals: data.totals || null,
        range: data.range || null,
      })
    );
  };
};

// Full, unfiltered gaze location list for the filter dropdown. Kept separate
// from the dashboard's byLocation (which shrinks when a location is filtered).
export const fetchGazeLocations = ({ siteId }) => {
  return async (dispatch) => {
    let res;
    try {
      res = await axios.post(
        `${url}/gazeAnalytic/locations`,
        { siteId },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
    } catch (error) {
      return dispatch(ANALYTICS_FETCH_GAZE_LOCATIONS_SUCCESS({ data: [] }));
    }
    return dispatch(
      ANALYTICS_FETCH_GAZE_LOCATIONS_SUCCESS({ data: res.data.data || [] })
    );
  };
};

const cancelToken = axios.CancelToken.source();
export const fetchAnalytics = ({
  start,
  end,
  type,
  adsumScreenIds,
  locations,
  siteId,
}) => {
  return async (dispatch) => {
    dispatch(ANALYTICS_FETCH_DATA_INIT());
    let analytic;
    try {
      if (type === 'trafficcounter') {
        analytic = await axios.post(
          `${url}/trafficAnalytic/analyticsMerged`,

          {
            start,
            end,
            siteId,
            location: locations,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
          }
        );
      }
      else if (type === 'emotionanalytic') {
        analytic = await axios.post(
          `${url}/emotionAnalytic/analytics`,

          {
            start,
            end,
            siteId,
            location: locations,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
          }
        );
      }
      else if (type === 'profileanalyzer') {
        analytic = await axios.post(
          `${url}/profileAnalytic/analytics`,

          {
            start,
            end,
            siteId,
            location: locations,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
          }
        );
      } else if (type === 'gazeanalytic') {
        // Gaze dashboard: SGT calendar dates as plain "YYYY-MM-DD" (no offset/Z).
        const startDate = start ? start.format('YYYY-MM-DD') : undefined;
        const endDate = end ? end.format('YYYY-MM-DD') : undefined;
        const groupBy =
          start && end && start.isSame(end, 'day') ? 'hour' : 'day';
        analytic = await axios.post(
          `${url}/gazeAnalytic/dashboard`,

          {
            siteId,
            startDate,
            endDate,
            locations,
            groupBy,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
          }
        );
        log(analytic.data, 'gaze analytic result');
        return dispatch(
          ANALYTICS_FETCH_DATA_SUCCESS({
            data: analytic.data.data,
            // Populate the location filter dropdown from byLocation.
            location: (analytic.data.data?.byLocation || []).map((b) => ({
              location: b.location,
            })),
          })
        );
      } else if (type === 'vehiclecounter') {
        analytic = await axios.post(
          `${url}/vehicleAnalytic/analytics`,

          {
            start,
            end,
            siteId,
            location: locations,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
          }
        );
      } else {
        analytic = await axios.post(
          `${url}/analytic/get`,

          {
            start,
            end,
            siteId,
            type,
            adsumScreenIds,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
          }
        );
      }
    } catch (error) {
      console.log(error);
      toastr.error('', `${errorMsg(dispatch, error)}`);
      return dispatch(ANALYTICS_FETCH_DATA_FAIL({ error }));
    }

    log(analytic.data, 'analytic result');
    // dispatch(calculateData({ data: analytic.data.rawData }));
    return dispatch(
      ANALYTICS_FETCH_DATA_SUCCESS({
        data: analytic.data.data,
        rawData: analytic.data.rawData,
        location: analytic.data.location,
      })
    );
  };
};



export const fetchLeaderboard = ({ start, end, siteId, adsumScreenIds }) => {
  return async (dispatch) => {
    dispatch(ANALYTICS_FETCH_LEADERBOARD_INIT());
    let analytic;
    try {
      analytic = await axios.post(
        `${url}/analytic/getTop`,

        {
          start,
          end,
          siteId,
          adsumScreenIds,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
    } catch (error) {
      console.log(error);
      toastr.error('', `${errorMsg(dispatch, error)}`);
      return dispatch(ANALYTICS_FETCH_LEADERBOARD_FAIL({ error }));
    }

    // dispatch(calculateData({ data: analytic.data.rawData }));
    return dispatch(
      ANALYTICS_FETCH_LEADERBOARD_SUCCESS({
        data: analytic.data.data,
      })
    );
  };
};

export const calculateData = ({ data }) => {
  return async (dispatch) => {
    dispatch(ANALYTICS_CALCULATE_DATA_INIT());

    console.log(data, 'data calculate');

    let result = [];

    const groupedDuration = _.groupBy(data, 'adsumScreenId');
    const keys = Object.keys(groupedDuration);

    for (const k of keys) {
      const content = groupedDuration[k];
      result.push({ x: k, y: content.length });
    }

    result = _.sortBy(result, 'y').reverse();
    console.log(result, 'sorted');

    return dispatch(
      ANALYTICS_CALCULATE_DATA_SUCCESS({
        rawData: result,
      })
    );
  };
};

export const downloadAnalyticsLeaderboard = (body) => {
  return async (dispatch) => {
    dispatch(ANALYTICS_EXPORT_ANALYTIC_INIT());
    console.log(body, 'body');

    axios
      .post(`${url}/analytic/export`, body, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
        responseType: 'blob',
      })
      .then((res) => {
        fileDownload(
          res.data,
          `logs_export_${body.type}_${moment(new Date()).format(
            'YYYY-MM-DD'
          )}.csv`
        );
        return dispatch(ANALYTICS_EXPORT_ANALYTIC_SUCCESS());
      })
      .catch((error) => {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(ANALYTICS_EXPORT_ANALYTIC_FAIL({ error }));
      });
  };
};

// Gaze dashboard export -> .xlsx blob. Same SGT date/location filters as the
// dashboard fetch; backend builds a 3-sheet workbook.
export const downloadGazeAnalytics = (body) => {
  return async (dispatch) => {
    dispatch(ANALYTICS_EXPORT_ANALYTIC_INIT());

    const { start, end, locations, siteId } = body;
    const startDate = start ? start.format('YYYY-MM-DD') : undefined;
    const endDate = end ? end.format('YYYY-MM-DD') : undefined;
    const groupBy = start && end && start.isSame(end, 'day') ? 'hour' : 'day';

    axios
      .post(
        `${url}/gazeAnalytic/export`,
        { siteId, startDate, endDate, locations, groupBy },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
          responseType: 'blob',
        }
      )
      .then((res) => {
        fileDownload(
          res.data,
          `gaze-analytics_${startDate || 'start'}_${endDate || 'end'}.xlsx`
        );
        return dispatch(ANALYTICS_EXPORT_ANALYTIC_SUCCESS());
      })
      .catch((error) => {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(ANALYTICS_EXPORT_ANALYTIC_FAIL({ error }));
      });
  };
};

export const downloadAnalytics = (body) => {
  return async (dispatch) => {
    dispatch(ANALYTICS_EXPORT_ANALYTIC_INIT());
    let dataExport;
    try{
      switch(body.type){
        case 'leaderboard':
          dataExport= await axios
            .post(`${url}/analytic/exportTop`, body, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
              },
              responseType: 'blob',
            });
          break;
        case 'trafficcounter':
          dataExport= await axios
            .post(`${url}/trafficAnalytic/export`, body, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
              },
              responseType: 'blob',
            });
          break;
          case 'profileanalyzer':
          dataExport= await axios
            .post(`${url}/profileAnalytic/export`, body, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
              },
              responseType: 'blob',
            });
          break;
        default:
          dataExport = await axios
            .post(`${url}/analytic/exportAll`, body, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
              },
              responseType: 'blob',
            });
      }
      fileDownload(
        dataExport.data,
        `logs_export_${body.type}_${moment(new Date()).format(
          'YYYY-MM-DD'
        )}.csv`
      );
    return dispatch(ANALYTICS_EXPORT_ANALYTIC_SUCCESS());
    }catch(error){
      toastr.error('', `${errorMsg(dispatch, error)}`);
      return dispatch(ANALYTICS_EXPORT_ANALYTIC_FAIL({ error }));
    }


    // if (body.type === 'leaderboard') {
    //   axios
    //     .post(`${url}/analytic/exportTop`, body, {
    //       headers: {
    //         Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
    //       },
    //       responseType: 'blob',
    //     })
    //     .then((res) => {
    //       fileDownload(
    //         res.data,
    //         `logs_export_${body.type}_${moment(new Date()).format(
    //           'YYYY-MM-DD'
    //         )}.csv`
    //       );
    //       return dispatch(ANALYTICS_EXPORT_ANALYTIC_SUCCESS());
    //     })
    //     .catch((error) => {
    //       toastr.error('', `${errorMsg(dispatch, error)}`);
    //       return dispatch(ANALYTICS_EXPORT_ANALYTIC_FAIL({ error }));
    //     });
    // } else {
    //   axios
    //     .post(`${url}/analytic/exportAll`, body, {
    //       headers: {
    //         Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
    //       },
    //       responseType: 'blob',
    //     })
    //     .then((res) => {
    //       fileDownload(
    //         res.data,
    //         `logs_export_rawdata_${moment(new Date()).format('YYYY-MM-DD')}.csv`
    //       );
    //       return dispatch(ANALYTICS_EXPORT_ANALYTIC_SUCCESS());
    //     })
    //     .catch((error) => {
    //       toastr.error('', `${errorMsg(dispatch, error)}`);
    //       return dispatch(ANALYTICS_EXPORT_ANALYTIC_FAIL({ error }));
    //     });
    // }
  };
};

export const cancelAction = () => {
  return async (dispatch, getState) => {
    try {
      cancelToken.cancel();
    } catch (error) {}

    return dispatch(
      ANALYTICS_FETCH_PROFILE_SUCCESS({
        data: {},
        location: [],
      })
    );
  };
};
export const loadingAnalytic = () => {
  return async (dispatch, getState) => {
    return dispatch(ANALYTICS_FETCH_DATA_INIT());
  };
};
